import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import PlayerForm from '../../../components/admin/player/PlayerForm'
import PlayerTable from '../../../components/admin/player/PlayerTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const PlayerPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PUBLISHERS, Branch.PLAYER_LAYER])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <PlayerForm />
      </Box>
      <Box paddingTop={3}>
        <PlayerTable />
      </Box>
    </Box>
  )
}

export default React.memo(PlayerPage)
